
export interface UpdateLocationsFromMlsRequest {
  locationId: string | null;
  jobId: string | undefined;
  planId: string | undefined;
}
